<div class="modal-header">
  <h3 class="modal-title">Attention, rouler le calcul de nouveau va effacer les résultats existants</h3>
</div>
<div class="modal-body">
  <p>En roulant le calcul de nouveau, les résultats existants vont être effacés et remplacés par les nouveaux
    résultats</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-light" data-bs-dismiss="modal" type="button">Ne pas
    calculer
  </button>
  <button (click)="activeModal.close(true)" class="btn btn-primary" type="button">Oui, je veux recalculer</button>
</div>
